import {Component, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {RagQA} from '../../services/ai/rag.service';

@Component({
    selector: 'app-rag-add-dialog',
    templateUrl: './rag-add-dialog.component.html',
    styleUrls: ['./rag-add-dialog.component.scss'],
    standalone: false
})
export class RagAddDialogComponent {
    qaForm: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<RagAddDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: RagQA,
        private fb: FormBuilder
    ) {
        this.qaForm = this.fb.group({
            question: ['', [Validators.required, Validators.minLength(3)]],
            answer: ['', [Validators.required, Validators.minLength(3)]],
            category: [''],
            videoId: ['']
        });
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onSubmit(): void {
        if (this.qaForm.valid) {
            this.dialogRef.close(this.qaForm.value);
        }
    }
}